import { ColorOptions, ModBox, Spacer } from '@jfs/ui-new'
import { TextInputNew } from '../../../../components/AdminInputs'
import { ButtonNew } from '../../../../components/AdminButton'
import { useEffect, useState } from 'react'
import { EmType } from '../..'
import { Dropdown } from '../../../../components/Dropdown'
import { TitleWithDashedLine } from '../../../../components/TitleWithDashedLine'
import { useLazyApiData, useStores } from '../../../../data/store'
import { styles } from '../../styles'
import { SelectParentEntityList } from '../CreateEntity/SelectParentEntityList'

const flexMapperWithIndex: any = {
  0: 1,
  1: 1,
}

const editflexMapper: any = {
  0: 1,
  1: 1,
  // 2: 1,
}
const headerData = [
  {
    title: 'Program Category',
  },
  {
    title: 'Reference ID',
  },
]

const headerDataEdit = [
  {
    title: 'Program Category',
  },
  {
    title: 'Reference ID',
  },
  //   {
  //     title: 'Actions',
  //   },
]

const ProgramDetails = ({ isEdit, selectedEntity, type }: any) => {
  const {
    programDetailsListByEntityId,
    programDetailsList,
    addProgramDetail,
    deleteProgramDetail,
    getLovsFromKey,
    programDetailsListLength,
    getMasProgramDetails,
    businessDetails,
    fetchProgramDetailsByIds,
    getProgramIds,
    getProgramIdsFromMasMid,
    getProgramDetailsListFromCreationFlow,
  } = useStores((store) => ({
    programDetailsListByEntityId: store.onboarding.getProgramDetailsListByEntityId,
    programDetailsList: store.onboarding.getProgramDetailsList,
    addProgramDetail: store.onboarding.addProgramDetail,
    deleteProgramDetail: store.onboarding.deleteProgramDetailRow,
    getLovsFromKey: store.getLovsFromKey,
    programDetailsListLength: store.onboarding.programDetails.length,
    getProgramCategoryLengthFromSearchEntity: store.onboarding.getProgramCategoryLengthFromSearchEntity,
    getMasProgramDetails: store.onboarding.getMasProgramDetails,
    businessDetails: store.onboarding.businessDetail,
    fetchProgramDetailsByIds: store.fetchProgramDetailsByIds,
    getProgramIds: store.getProgramIds,
    getProgramIdsFromMasMid: store.getProgramIdsFromMasMid,
    getProgramDetailsListFromCreationFlow: store.onboarding.getProgramDetailsListFromCreationFlow,
  }))
  const [referenceId, setReferenceId] = useState('')
  const [programCategory, setProgramCategory] = useState('')
  const [mProgramDetailsList, setmProgramDetailsList] = useState([])

  const [fetchProgramNameMapping, fetchProgramNameMappingHAndler] = useLazyApiData(fetchProgramDetailsByIds)
  const onChangeData = (key: string, value: string) => {
    if (key === 'referenceId') {
      setReferenceId(value)
    } else {
      setProgramCategory(value)
    }
  }

  useEffect(() => {
    if (fetchProgramNameMappingHAndler?.state === 'fulfilled' && selectedEntity && selectedEntity?.id) {
      const data = programDetailsListByEntityId(selectedEntity?.id, isEdit)
      setmProgramDetailsList(data)
    } else if (fetchProgramNameMappingHAndler?.state === 'fulfilled' && type === EmType.createSingleEntity && !isEdit) {
      setmProgramDetailsList(getProgramDetailsListFromCreationFlow())
    }
  }, [
    fetchProgramNameMappingHAndler?.state,
    getProgramDetailsListFromCreationFlow,
    isEdit,
    programDetailsListByEntityId,
    selectedEntity,
    type,
  ])

  useEffect(() => {
    if (selectedEntity && selectedEntity.id) {
      const programIds = getProgramIds(selectedEntity.id)
      if (programIds?.length > 0) {
        fetchProgramNameMapping(programIds)
      }
    } else {
      // const data = type === EmType.createSingleEntity && !isEdit ? getMasProgramDetails() : programDetailsList() // parseProgramDetails('ID1|ID2|ID3|ID4->RID1|RID2||RID4')
      const programIds = getProgramIdsFromMasMid()
      if (programIds?.length > 0) {
        fetchProgramNameMapping(programIds)
      }
    }
  }, [
    fetchProgramNameMapping,
    getMasProgramDetails,
    getProgramIds,
    isEdit,
    programDetailsList,
    programDetailsListByEntityId,
    selectedEntity,
    type,
  ])

  console.log('mProgramDetailsList: ', selectedEntity, mProgramDetailsList)

  const onAddPress = () => {
    const id = `${mProgramDetailsList?.length + 1}`
    addProgramDetail(selectedEntity?.id, isEdit, id, programCategory, referenceId)
  }

  const onDeleteRow = (item: any) => {
    deleteProgramDetail(item, selectedEntity?.id ?? '')
  }

  const onRefIdChange = (val: any) => {
    if (!isNaN(val)) {
      onChangeData('referenceId', val)
    }
  }
  return (
    <ModBox show={type === EmType.Search || type === EmType.createSingleEntity}>
      <ModBox show={mProgramDetailsList?.length > 0}>
        <TitleWithDashedLine title={'Program Details'} />
      </ModBox>
      <ModBox show={false} direction="row" marginTop={32} alignItems={'center'}>
        <ModBox minWidth={270} show={true}>
          <Dropdown
            selectedData={(value) => onChangeData('programCategory', value)}
            minWidth={270}
            label={'Program Category'}
            value={programCategory}
            title={''}
            data={getLovsFromKey('ProgramCategory')}
          />
        </ModBox>
        <Spacer size={32} direction={'horizontal'} />
        <ModBox minWidth={270} show={true}>
          <TextInputNew
            value={referenceId}
            {...styles.textinputStyle}
            label={'Reference ID'}
            focusBorderColor={'DISABLED_GREY'}
            onChange={onRefIdChange}
            onFocusBorderWidth={1}
            color={'BLACK_21' as ColorOptions}
            paddingHorizontal={16}
            selectionColor={'BLUE'}
            paddingVertical={9}
            type="body12"
            borderColor={'#d1d3e2' as ColorOptions}
            borderRadius={4}
            fontSize={12}
            labelFontFamily={'jiotype-bold'}
            labelColor={'#757575' as ColorOptions}
            labelPaddingBottom={10}
          />
        </ModBox>
        <Spacer size={32} direction={'horizontal'} />
        <ModBox marginTop={28} show={true}>
          <ButtonNew
            type={'secondaryIconSmall'}
            borderWidth={1}
            title={'Add'}
            borderColor={'#0070B6'}
            borderRadius={4}
            icon="ADD"
            onPress={onAddPress}
          />
        </ModBox>
      </ModBox>
      <ModBox show={mProgramDetailsList?.length > 0} marginTop={16}>
        <SelectParentEntityList
          title={''}
          hide={false}
          data={mProgramDetailsList}
          headerTitles={isEdit ? headerDataEdit : headerData}
          columnFlexMapper={isEdit ? editflexMapper : flexMapperWithIndex}
          onDelete={onDeleteRow}
        />
      </ModBox>
    </ModBox>
  )
}

export { ProgramDetails }
